module.exports = __webpack_public_path__ + "img/113.b75d5cb2.jpg";